import { paths } from 'src/routes/paths';

import { ACCESS_TOKEN_KEY,REFRESH_TOKEN_KEY } from './constant';

// ----------------------------------------------------------------------

export function jwtDecode(token) {
  try {
    if (!token) {
      console.error('No token provided');
      return null;
    }

    const parts = token.split('.');
    if (parts.length < 2) {
      console.error('Invalid token format:', token);
      throw new Error('Invalid token!');
    }

    const base64Url = parts[1];

    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

    const decoded = JSON.parse(atob(base64));


    return decoded;
  } catch (error) {
    console.error('Error decoding token:', error);
    throw error;
  }
}

// ----------------------------------------------------------------------

export function isValidToken(accessToken) {
  if (!accessToken) {
    return false;
  }

  try {
    const decoded = jwtDecode(accessToken);

    if (!decoded || !('exp' in decoded)) {
      return false;
    }

    const currentTime = Date.now() / 1000;

    return decoded.exp > currentTime;
  } catch (error) {
    return false;
  }
}

// ----------------------------------------------------------------------

export function tokenExpired(exp, refreshToken) {
  const currentTime = Date.now() / 1000;
  const timeLeft = exp - currentTime;

  setTimeout(async () => {
    try {
      await refreshToken();
    } catch (error) {
      localStorage.removeItem(ACCESS_TOKEN_KEY);
      localStorage.removeItem(REFRESH_TOKEN_KEY);
      window.location.href = paths.auth.jwt.signIn;
    }
  }, timeLeft * 1000 - 60000); // Refresh 1 minute before expiration
}

// ----------------------------------------------------------------------